var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWeekend = function SvgWeekend(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_711_2307)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 10,
    width: 16,
    height: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_711_2307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8274 12.7101C27.4209 12.7645 27.0071 12.7329 26.6145 12.6174C26.2219 12.5019 25.8598 12.3053 25.5532 12.0411C25.2709 12.37 24.9136 12.6308 24.5095 12.8029C24.1053 12.975 23.6654 13.0537 23.2244 13.0328C22.7835 13.012 22.3536 12.892 21.9687 12.6825C21.5838 12.473 21.2544 12.1797 21.0067 11.8257C20.5331 12.576 19.7854 13.1262 18.9122 13.367C18.039 13.6077 17.1043 13.5213 16.2939 13.125V15.3945C16.2939 15.8868 16.092 16.359 15.7327 16.7071C15.3733 17.0552 14.886 17.2508 14.3778 17.2508C13.8696 17.2508 13.3822 17.0552 13.0229 16.7071C12.6636 16.359 12.4617 15.8868 12.4617 15.3945L12.4594 13.0362C12.0417 13.0363 11.6292 12.9471 11.2511 12.7751C10.873 12.6031 10.5387 12.3525 10.272 12.0411C9.78275 12.4631 9.15768 12.7079 8.50311 12.7339C7.84854 12.7599 7.2049 12.5654 6.68164 12.1835V36.1594C6.68164 36.4886 6.81663 36.8043 7.05691 37.037C7.29719 37.2698 7.62308 37.4006 7.96289 37.4006H27.8617C28.2015 37.4006 28.5274 37.2698 28.7677 37.037C29.0079 36.8043 29.1429 36.4886 29.1429 36.1594V12.1835C28.7581 12.4651 28.3052 12.6464 27.8274 12.7101Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_711_2307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1422 20.4617C29.9936 15.8134 33.1938 15.127 34.7848 15.6502C36.5988 16.2466 36.659 18.3706 36.3771 20.0456C35.462 25.4831 31.5503 28.1346 29.1396 26.3758L29.1425 31.1855C31.8264 30.3325 37.8887 27.6372 39.0674 20.4599C40.399 12.342 32.8114 11.4142 29.1525 14.422L29.1422 20.4617Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.141 31.184V36.1581C29.141 36.4873 29.006 36.803 28.7657 37.0358C28.5254 37.2685 28.1995 37.3993 27.8597 37.3993H7.96191C7.62211 37.3993 7.29622 37.2685 7.05593 37.0358C6.81565 36.803 6.68066 36.4873 6.68066 36.1581V31.184L7.68324 32.3321C8.1346 32.8458 8.69576 33.2583 9.3279 33.5412C9.96005 33.8241 10.6481 33.9706 11.3444 33.9705H24.4772C25.1736 33.9706 25.8616 33.8241 26.4938 33.5412C27.1259 33.2583 27.6871 32.8458 28.1384 32.3321L29.141 31.184Z",
    fill: "#F28300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79102 18.9678H9.54766L10.3162 22.2207H10.3281L11.1861 18.9678H11.9487L12.7828 22.2207H12.7947L13.5871 18.9678H14.3437L13.17 23.2217H12.4134L11.5614 19.9687H11.5495L10.6796 23.2217H9.91108L8.79102 18.9678Z",
    fill: "#E37B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0569 18.9678H18.1192V19.6112H15.8017V20.7253H17.9465V21.333H15.8017V22.5782H18.1609V23.2217H15.0569V18.9678Z",
    fill: "#E37B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0323 18.9678H22.0947V19.6112H19.7771V20.7253H21.9219V21.333H19.7771V22.5782H22.1364V23.2217H19.0323V18.9678Z",
    fill: "#E37B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0078 18.9678H23.7525V20.9041L25.6471 18.9678H26.5646L24.8666 20.6658L26.6837 23.2217H25.7543L24.3602 21.19L23.7525 21.7918V23.2217H23.0078V18.9678Z",
    fill: "#E37B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7485 26.415H14.8108V27.0585H12.4932V28.1726H14.638V28.7803H12.4932V30.0255H14.8525V30.6689H11.7485V26.415Z",
    fill: "#E37B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6941 26.415H16.4806L18.4228 29.5488H18.4347V26.415H19.1437V30.6689H18.3573L16.421 27.5411H16.4031V30.6689H15.6941V26.415Z",
    fill: "#E37B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2462 26.415H22.0097C22.3354 26.415 22.6174 26.4706 22.8558 26.5819C23.0941 26.6931 23.2887 26.846 23.4396 27.0406C23.5905 27.2313 23.7018 27.4557 23.7733 27.7138C23.8487 27.972 23.8865 28.2481 23.8865 28.542C23.8865 28.8359 23.8487 29.1119 23.7733 29.3701C23.7018 29.6283 23.5905 29.8547 23.4396 30.0493C23.2887 30.24 23.0941 30.3909 22.8558 30.5021C22.6174 30.6133 22.3354 30.6689 22.0097 30.6689H20.2462V26.415ZM20.991 30.0612H21.7238C22.0137 30.0612 22.25 30.0235 22.4327 29.948C22.6194 29.8686 22.7644 29.7613 22.8677 29.6263C22.9749 29.4873 23.0464 29.3264 23.0821 29.1437C23.1219 28.957 23.1417 28.7565 23.1417 28.542C23.1417 28.3275 23.1219 28.1289 23.0821 27.9462C23.0464 27.7595 22.9749 27.5987 22.8677 27.4636C22.7644 27.3246 22.6194 27.2174 22.4327 27.1419C22.25 27.0625 22.0137 27.0227 21.7238 27.0227H20.991V30.0612Z",
    fill: "#E37B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11514 6.66883C9.13451 6.66883 9.15381 6.66899 9.17318 6.66939C10.0281 4.76925 12.0567 3.48242 14.3909 3.48242C15.7312 3.48242 17.0205 3.92318 18.029 4.69788C18.9021 3.92231 20.0135 3.48242 21.174 3.48242C22.7727 3.48242 24.2427 4.32459 25.1439 5.65603C25.7603 5.27876 26.4648 5.07563 27.2034 5.07563C29.4891 5.07563 31.3486 7.04109 31.3486 9.45695C31.3486 10.7602 30.7842 11.9942 29.8413 12.8196V14.5889C29.8413 16.2388 28.5759 17.5762 27.015 17.5762C25.454 17.5762 24.1887 16.2388 24.1887 14.5889V13.8383H9.17529C7.27753 13.8383 5.69164 12.1968 5.72412 10.1913C5.75563 8.24324 7.26472 6.66883 9.11514 6.66883Z",
    fill: "#F28300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_711_2307",
    x: 4.68164,
    y: 10.8257,
    width: 26.4609,
    height: 29.5748,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.466667 0 0 0 0 0.28 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_711_2307"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_711_2307",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_711_2307",
    x: 27.1396,
    y: 11.8466,
    width: 14.083,
    height: 22.3389,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.466667 0 0 0 0 0.28 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_711_2307"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_711_2307",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_711_2307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWeekend);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/weekend.17a51edcfbc0dedb70731523e0737bd7.svg";